/**
 * Shared cover-image imports for the pricing surfaces.
 *
 * Both `models-pricing-data.ts` and `payg-pricing-data.ts` reference the same
 * underlying PNGs to keep the model grid and the API calculator visually
 * consistent. Centralising the imports avoids drift if assets are renamed and
 * keeps the two data files focused on their own product taxonomies.
 */

export { default as FlashCover } from "../covers/Flash.png";
export { default as MultilingualCover } from "../covers/Multilingual.png";
export { default as ScribeCover } from "../covers/Scribe.png";
export { default as ScribeRealtimeCover } from "../covers/Scribe realtime.png";
export { default as MusicCover } from "../covers/Music.png";
export { default as VoiceChangerCover } from "../covers/Voice changer.png";
export { default as VoiceIsolatorCover } from "../covers/Voice Isolator.png";
export { default as SFXCover } from "../covers/SFX.png";
export { default as DubbingCover } from "../covers/Dubbing.png";
